import * as PIXI from 'pixi.js';
import { LayoutContainer } from '@pixi/layout/components'; // eslint-disable-line
import TappableGraphicsButton from './TappableGraphicsButton';

export const COST_FILTERS = ['0', '1', '2', '3', '4', '5', '6', '7+'];

const COST_OFF_FILL = new PIXI.FillGradient({
    type: 'linear',
    start: { x: 0, y: 0 },
    end: { x: 0, y: 1 },
    colorStops: [
        { offset: 0, color: '#e0eefc' },
        { offset: 1, color: '#97bade' },
    ],
});

function costButtonStyle(size, selected) {
    const scale = size / 100;
    const shared = {
        width: size,
        height: size,
        cornerRadius: size / 2,
        fontFamily: 'Fugaz One',
        fontSize: 50 * scale,
        fontWeight: 'normal',
    };
    if (selected) {
        return {
            ...shared,
            backgroundColor: '#4c5769',
            borderColor: '#e0eefc',
            borderWidth: 9 * scale,
            fontColor: '#e3eefb',
        };
    }
    return {
        ...shared,
        fill: COST_OFF_FILL,
        borderWidth: 0,
        fontColor: '#333333',
    };
}

export function cardMatchesCostFilter(card, selectedCosts) {
    if (!selectedCosts || selectedCosts.size === 0) return true;
    const cost = Number(card.cost);
    if (!Number.isFinite(cost)) return false;
    if (cost >= 7) return selectedCosts.has('7+');
    return selectedCosts.has(String(cost));
}

function replaceButton(previous, button, parent) {
    if (previous?.parent) {
        const index = previous.parent.getChildIndex(previous);
        previous.parent.addChildAt(button, index);
        previous.destroy();
        return;
    }
    parent.addChild(button);
}

export default class CostFiltersRow extends LayoutContainer {
    constructor({
        width,
        height = 110,
        buttonSize = 100,
        paddingLeft = 50,
        paddingRight = 50,
        gap = 0,
        multiple = true,
        selected = [],
        onChange = null,
    } = {}) {
        super();

        this.label = 'costFiltersRow';
        this.buttonSize = buttonSize;
        this.multiple = multiple;
        this.onChange = onChange;
        this.selected = new Set(selected);
        this.buttons = {};
        this.layout = {
            width,
            height,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft,
            paddingRight,
            ...(gap ? { gap } : {}),
        };

        this.refresh();
    }

    setSelected(selected) {
        this.selected = new Set(selected);
        this.refresh();
    }

    toggle(cost) {
        if (this.selected.has(cost)) {
            this.selected.delete(cost);
        } else if (this.multiple) {
            this.selected.add(cost);
        } else {
            this.selected.clear();
            this.selected.add(cost);
        }
        this.refresh();
        this.onChange?.(this.selected);
    }

    refresh() {
        for (const cost of COST_FILTERS) {
            this.updateButton(cost);
        }
    }

    updateButton(cost) {
        const previous = this.buttons[cost];
        const button = new TappableGraphicsButton({
            text: cost,
            ...costButtonStyle(this.buttonSize, this.selected.has(cost)),
        });
        button.onButtonTap = () => this.toggle(cost);
        replaceButton(previous, button, this);
        this.buttons[cost] = button;
    }
}
